import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useConfiguration } from "../hooks/useConfiguration";
import { useUnsavedChanges } from "../hooks/useUnsavedChanges";
import { CHANNEL_LABELS } from "../lib/steps";

export function FinishStep() {
  const { policyDraft, policyDirty, requestsDirty, defaultsDirty } =
    useConfiguration();
  const { requestStep } = useUnsavedChanges();
  const rows = [
    { label: "Coverage path", dirty: policyDirty, step: 1 },
    { label: "Request assignments", dirty: requestsDirty, step: 4 },
    { label: "Defaults", dirty: defaultsDirty, step: 5 },
  ];

  return (
    <Stack spacing={2}>
      <Box sx={{ bgcolor: "#f8fafc", p: 2, border: "1px solid #e4e7ec" }}>
        <Typography sx={{ fontWeight: 700, mb: 1 }}>
          {policyDraft.displayName || "Coverage"}
        </Typography>
        {policyDraft.tiers.map((tier) => (
          <Typography key={tier.tierOrder} sx={{ fontSize: "0.95rem", mb: 0.5 }}>
            {tier.tierOrder}. {tier.displayName} — {tier.timeoutSeconds}s —{" "}
            {tier.channels
              .map(
                (channel) =>
                  CHANNEL_LABELS[channel.channelCode ?? ""] ||
                  channel.channelCode ||
                  "contact",
              )
              .join(", ") || "no contacts yet"}
          </Typography>
        ))}
      </Box>
      {rows.map((row) => (
        <Box
          key={row.label}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            border: "1px solid #e4e7ec",
            p: 1.5,
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 700 }}>{row.label}</Typography>
            <Typography sx={{ color: "text.secondary", fontSize: "0.9rem" }}>
              {row.dirty ? "Unsaved changes" : "Saved"}
            </Typography>
          </Box>
          <Button size="small" onClick={() => requestStep(row.step)}>
            Edit
          </Button>
        </Box>
      ))}
    </Stack>
  );
}
